import store from '../store/store';
import {
  removeAllModals,
  pushModal,
  removeModalById,
} from '../store/actions/modal-actions';

import { uniqueId, includes } from './helpers';

const modalCloseAnimationTimeout = 300;

/**
 * It is closing (set `isOpen` to false) and removes modals.
 * Used in the `systemModal` reducer for `CLOSE_ALL_MODALS` action.
 * @param {object[]} modalStack List of Modal data
 */
 export const closeAndClearAllSystemModals = modalStack => {
  setTimeout(
    () => store.dispatch(removeAllModals()),
    modalCloseAnimationTimeout
  );
  return modalStack.map(modal => ({
    ...modal,
    isOpen: false,
  }));
};

/**
 * Adds or updates existing modal.
 * Used in the `systemModal` reducer for `PUSH_MODAL` action
 * @param {object[]} modalStack List of Modal data
 * @param {object} modal New or Updated Modal data
 */
export const addOrUpdateSystemModal = (modalStack, modal) => {
  const modalAlreadyPresent =  includes(modalStack.map(stackedModal => stackedModal.modalId), modal.modalId)

  if (modalAlreadyPresent === true) {
    return modalStack.map(stackedModal =>
      stackedModal.modalId === modal.modalId
        ? {
            ...modal,
            isOpen: true,
            modalId: modal.modalId || uniqueId(),
          }
        : {
            ...stackedModal,
          }
    );
  }
  return [
    ...modalStack,
    {
      ...modal,
      isOpen: true,
      modalId: modal.modalId || uniqueId(),
    },
  ];
};

/**
 * Closes (sets the `isOpen` to `false`) modal with given `modalId`.
 * Used in the `systemModal` reducer for `CLOSE_MODAL_BY_ID` action.
 * @param {object[]} modalStack List of Modal data
 * @param {string} modalId Modal ID
 */
export const closeAndClearSystemModalById = (modalStack, modalId) => {
  setTimeout(
    () => store.dispatch(removeModalById(modalId)),
    modalCloseAnimationTimeout
  );
  return modalStack.map(modal =>
    modalId === modal.modalId
      ? {
          ...modal,
          isOpen: false,
        }
      : {
          ...modal,
        }
  );
};

/**
 * Helper to dispatch the `pushModal` action that will display modal.
 * @param {object} modal Modal data object
 */
export const pushSystemModal = modal => {
  store.dispatch(pushModal(modal));
};
